import { Field } from 'formik';
import { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
const TextBox = ({
  label,
  name,
  isRequired,
  placeholder,
  value,
  defaultValue,
  handleChange,
  maxLength,
  minLength,
  errormsg,
  fieldFlag,
  disabled,
  fieldType,
  fieldClass,
}) => {
  const checkURL = (value) => (value.startsWith('http') ? value : `https://${value}`);
  const [showInfo, setShowInfo] = useState(false);
  return (
    <>
      <div className={fieldClass === 'dollarValue' ? 'dollarField' : 'textBoxField'}>
        <label htmlFor={name}>
          {label}
          {isRequired && <span className="required-star">*</span>}
          {name === 'amount' && (
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip id={`tooltip-${name}`}>Expected Order Value</Tooltip>}
            >
              <i
                className="bi bi-info-circle-fill"
                style={{ color: 'lightblue', marginLeft: '8px' }}
              ></i>
            </OverlayTrigger>
          )}
        </label>
        <div className={fieldClass === 'dollarValue' ? 'dlrFld' : 'dfltText'}>
          {fieldClass === 'dollarValue' && value && <span className="dollarValue">$</span>}
          {disabled && ['email', 'phone', 'link'].includes(fieldType) ? (
            value ? (
              <>
                {fieldType === 'email' && <Link to={`mailto:${value}`}>{value}</Link>}
                {fieldType === 'phone' && <Link to={`tel:${value}`}>{value}</Link>}
                {fieldType === 'link' && (
                  <Link to={checkURL(value)} target="_blank" rel="noopener noreferrer">
                    {value}
                  </Link>
                )}
              </>
            ) : (
              <span className="text"> --</span>
            )
          ) : (
            <Field
              className={`formik-input ${disabled ? ' disabled' : ''} ${errormsg ? 'errorField' : ''}`}
              type="text"
              name={name}
              style={{ width: '100%' }}
              autoComplete="given-name"
              id={name}
              disabled={disabled}
              value={value ?? defaultValue ?? ''}
              onChange={(e) => handleChange(e, fieldFlag)}
              {...(maxLength && maxLength > 0 ? { maxLength: maxLength } : {})}
              {...(minLength && minLength > 0 ? { minLength: minLength } : {})}
              {...(placeholder ? { placeholder: placeholder } : {})}
            />
          )}

          {errormsg && <div className="error-message">{errormsg}</div>}
        </div>
      </div>
    </>
  );
};

export default TextBox;
